export type NutritionEstimate = {
  name: string;
  value: EstimateValues;
  bracket: string;
};

export enum EstimateValues {
  High = "high",
  Med = "med",
  Low = "low",
}
